export const USER_ACCESS_HISTORY_SUBMISSION_SUBPATH = 'submissions'
export const SUBMISSION_ID_PARAM = 'submissionId'
